'use client';

/**
 * Interval cycling for loader copy. The loader uses the index form internally for its `messages`
 * subtitle; the text form is the public one, for callers who want a title that advances on its own
 * rather than one they set themselves.
 */

import { useEffect, useState } from 'react';

/** Current index, advancing every `intervalMs`, looping. Idle for 0-1 items. */
export const useCycledIndex = (count: number, intervalMs: number) => {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (count <= 1) return;
    const id = window.setInterval(() => setIndex((i) => (i + 1) % count), intervalMs);
    return () => window.clearInterval(id);
  }, [count, intervalMs]);
  return count > 0 ? index % count : 0;
};

/**
 * The current line of `texts`, moving on every `intervalMs`. Pass it to AiLoader's `title` for a
 * self-advancing first line. A single text holds forever and an empty list gives an empty string.
 */
export const useCycledText = (texts: string[], intervalMs = 3000) => {
  const index = useCycledIndex(texts.length, intervalMs);
  return texts[index] ?? '';
};
